<template>
  <div class="hmi-label" :style="{
    background: color,
    width: typeof width === 'number' ? width + 'px' : width,
    height: typeof height === 'number' ? height + 'px' : height,
    border: border,
  }" @click="handleClick">
    <v-label class="label">{{ label }}</v-label>
    <v-icon v-if="active == '1'" color="red" class="square">mdi-square</v-icon>
    <v-icon v-else-if="active == '0'" color="transparent" class="square">mdi-square</v-icon>

    <NumericKeypad ref="keypad" @input="emit"></NumericKeypad>
  </div>
</template>

<script>
import NumericKeypad from "./NumericKeypad.vue";

export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "white",
    },
    height: {
      type: [Number, String],
      default: "fit-content",
    },
    width: {
      type: [Number, String],
      default: "fit-content",
    },
    border: {
      type: String,
      default: "2px solid #000",
    },
    size: {
      type: Number,
      default: 20,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    active: {
      type: String,
      default: "",
    },
  },
  components: {
    NumericKeypad,
  },
  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    handleClick() {
      if (this.editable) {
        this.$refs.keypad.open();
      }
    },
    emit(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style scoped>
.hmi-label {
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  /* padding: 20px; */
}

.label {
  text-align: center;
  font-family: "Courier New", Courier, monospace !important;
  color: black;
  font-size: clamp(10px, 2.3vw, 21px) !important;
}

.square {
  padding-left: 10px !important;
}
</style>
